import type { AsyncSelectOption } from "../../../../components/Form/AsyncSearchableSelect/AsyncSearchableSelect";

export type LabelledResearcher = {
  id: string;
  name: string;
  email?: string | null;
};

export function researcherOption({ id, name, email }: LabelledResearcher): AsyncSelectOption {
  const trimmedEmail = email?.trim();
  return { value: id, label: name, description: trimmedEmail || undefined };
}

export function researcherOptionMatchesSearch(option: AsyncSelectOption, term: string): boolean {
  const haystack = `${option.label} ${option.description ?? ""}`.toLowerCase();
  return haystack.includes(term);
}
